import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { BonusProgressResponseModel } from '@/types/dashboard'

export const getKpiBonusProgress = async (
  startDate: string,
  endDate: string
): Promise<BonusProgressResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/kpi/bonus-progress/`, {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
